import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const CaseStudyCard = ({ study, index }) => (
  <Link
    to={`/case-study/${study.id}`}
    data-testid={`case-study-card-${study.id}`}
    className="group block"
  >
    <article className="relative h-full overflow-hidden rounded-2xl border border-border bg-card transition-all duration-500 hover:-translate-y-1.5 hover:border-coral/60 hover:shadow-[0_24px_60px_-24px_rgba(244,63,94,0.35)] flex flex-col">
      <div className="relative aspect-[16/10] overflow-hidden">
        <img
          src={study.image}
          alt={`${study.title} — ${study.category}`}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-navy-deep/10 transition-colors duration-500 group-hover:bg-transparent" />
        <span className="absolute left-4 top-4 rounded-full bg-background/85 px-3 py-1 font-mono text-[11px] uppercase tracking-[0.18em] text-foreground backdrop-blur-md">
          {study.category}
        </span>
        <span className="absolute right-4 top-4 font-display text-sm font-bold text-white/80">
          {String(index + 1).padStart(2, "0")}
        </span>
      </div>
      <div className="flex h-full flex-col p-6 sm:p-8">
        <h3 className="font-display text-xl font-bold tracking-tight sm:text-2xl">
          {study.title}
          <span className="text-coral">.</span>
        </h3>
        <p className="mt-1 text-sm text-muted-foreground">{study.subtitle}</p>
        
        {/* Problem → Outcome */}
        <div className="mt-6 flex-1">
          <div className="space-y-4">
            <div>
              <h4 className="mb-2 font-mono text-[10px] uppercase tracking-[0.2em] text-destructive">
                Problem
              </h4>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {study.challenge.split('.')[0]}.
              </p>
            </div>
            <div>
              <h4 className="mb-2 font-mono text-[10px] uppercase tracking-[0.2em] text-coral">
                Outcome
              </h4>
              <p className="text-sm text-foreground leading-relaxed">
                {study.solution.split('.')[0]}.
              </p>
            </div>
          </div>
        </div>

        {/* Stack Tags */}
        <div className="mt-6 pt-5 border-t border-border">
          <div className="flex flex-wrap gap-2 mb-4">
            {study.tags.slice(0, 4).map((tag) => (
              <span
                key={tag}
                className="rounded-full bg-card border border-border px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.12em] text-muted-foreground transition-colors duration-300 group-hover:border-coral/50 group-hover:text-foreground"
              >
                {tag}
              </span>
            ))}
          </div>
          
          {/* CTA */}
          <div className="flex items-center justify-between">
            <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-coral transition-colors duration-300 group-hover:text-coral">
              Read case study
            </span>
            <span className="flex h-10 w-10 items-center justify-center rounded-full border border-border transition-all duration-300 group-hover:border-coral group-hover:bg-coral group-hover:text-white">
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </span>
          </div>
        </div>
      </div>
    </article>
  </Link>
);
